<template>
  <!-- 套餐模式  -->
  <div class="content">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span style="font-weight: bolder">基本信息</span>
        <el-button v-if="pondData.status == 1" style="margin-left:10px" size="mini" type="primary" v-hasPermi="['pondManage:allocation']" @click="handleCardAllocation">池卡分配</el-button>
      </div>
      <el-descriptions :column="3" :contentStyle="{'font-size': '15px'}" :labelStyle="{'font-weight': 'bold','color':'#303133'}">
          <el-descriptions-item label="池ID">{{pondData.id}}</el-descriptions-item>
          <el-descriptions-item label="池代理商">{{pondData.companyName}}</el-descriptions-item>
          <el-descriptions-item label="池名称">{{pondData.poolName}}</el-descriptions-item>
          <el-descriptions-item label="池类型">
            <el-tag type="success">{{pondData.poolType}}</el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="运营类型">
             <el-tag style="margin-right:8px;" size="small" :key="item" v-for="item in pondData.operationTypes">{{item}}</el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="池状态">
            <el-tag size="small" v-if="pondData.status == 1">启用中</el-tag>
            <el-tag size="small" type="warning" v-else>未启用</el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="自动停开机" v-if="adminShow">
            <el-tag size="small" v-if="pondData.stopCard == 1">是</el-tag>
            <el-tag size="small" type="warning" v-else>不停机</el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="池成员">{{pondData.cardCount}}/PCS</el-descriptions-item>
          <el-descriptions-item label="单卡月峰值">
            <span v-if="editShow">
              {{pondData.strSingleFlowLimit}}
              <i class="el-icon-edit" @click="editShow = !editShow"></i>
            </span>
            <span v-if="!editShow">
              <el-input v-model="singleFlowLimit" style="width: 90px;" @blur="handleSingleFlowLimit" class="span-input">
                <i
                  class="el-icon-close el-input__icon"
                  slot="suffix"
                  @click="editShow = true">
                </i>
              </el-input>
            </span>
          </el-descriptions-item>
          <el-descriptions-item label="单卡停机保号费">{{pondData.cardProductFee}} 元/月</el-descriptions-item>
          <el-descriptions-item label="单卡功能管理费">{{pondData.cardFunctionFee}} 元/月</el-descriptions-item>
          <el-descriptions-item label="单卡月流量">{{pondData.strSingleFlow}}</el-descriptions-item>
          <el-descriptions-item label="单卡月费用">{{pondData.singlePrice}} 元/月</el-descriptions-item>
          <el-descriptions-item label="创建时间">{{pondData.createTime}}</el-descriptions-item>
      </el-descriptions>
    </el-card>
    <!-- 池套餐详情 -->
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span style="font-weight: bolder">池详情</span>
      </div>
      <el-form :inline="true" label-width="68px" v-if="lastThreeMonthDate && lastThreeMonthDate.length>0">
        <el-form-item>
          <el-select v-model="month" placeholder="请选择月份" @change="initPoolProductDetails" clearable @clear="initPoolProductDetails" >
            <el-option
                v-for="item in lastThreeMonthDate"
                :key="item.month"
                :label="item.month"
                :value="item.month">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <el-table :data="poolDetailProducts" border :header-cell-style ="{background: '#EEF1F6',color: '#606266'}">
        <el-table-column type="index" label="序号" align="center" width="60px"></el-table-column>
        <el-table-column prop="poolName" label="池名称" align="center"></el-table-column>
        <el-table-column prop="startTime" label="开始时间" align="center"></el-table-column>
        <el-table-column prop="endTime" label="到期时间" align="center"></el-table-column>
        <el-table-column prop="useFlow" label="已用流量(M)" align="center"></el-table-column>
        <el-table-column prop="cardNum" label="成员数" align="center"></el-table-column>
        <el-table-column prop="totalFlow" label="池总量(M)" align="center" :formatter="dataFormat"></el-table-column>
      </el-table>
    </el-card>
    <!-- 池成员 -->
    <PoolCardList ref="childCardList" :poolId="poolId" :userId="pondData.userId" :status="pondData.status"></PoolCardList>
  </div>
</template>
<script>
import {
  changeFlowPoolLimit,
  poolGetFlowPoolDetail,
  poolGetFlowPoolRenewRecord,
} from "@/api/api.js";
import PoolCardList from "./PoolCardList.vue";
export default {
  name:'packagePondDetail',
  components: { 
    PoolCardList
  },
  props: {
    poolId: {
      type: String
    }
  },
  data() {
    return{
      pondData:{},
      editShow:true,
      singleFlowLimit:"",
      month:undefined,
      lastThreeMonthDate:[],
      poolDetailProducts:[],
    }
  },
  computed: {
    adminShow(){
        return this.$store.getters.user.userType =='1'
    },
  },
  methods: {
    dataFormat(row, column, value){
      return value == null ? '-' : value
    },
    //卡分配
    handleCardAllocation(){
      this.$router.push({name:"pondTransfer",params: { poolId: this.poolId , userId:this.pondData.userId }});
    },
    // 池套餐详情
    initPoolProductDetails(){
      let poolId = this.poolId
      poolGetFlowPoolRenewRecord({poolId , month:this.month}).then(res => {
        this.lastThreeMonthDate = res.data.data.lastThreeMonthDate;
        this.poolDetailProducts = res.data.data.tableDetailData;
      })
    },
    // 流量池详情
    informationData(){
      let poolId = this.poolId
      poolGetFlowPoolDetail({poolId}).then(res => {
        this.pondData = res.data.data;
      })
    },
    
    handleSingleFlowLimit(){
      if(!this.singleFlowLimit){
        return this.$message.error("请输入池峰值");
      }
      let params = {
        poolId:this.poolId,
        singleFlowLimit:this.singleFlowLimit
      };
      changeFlowPoolLimit(params).then(res=>{
        this.pondData.strSingleFlowLimit = res.data.data;
        this.editShow = true;
        this.$refs.childCardList.initPoolCardData();
      })
    },
  },
  created() {
    this.informationData();
    this.initPoolProductDetails();
  },
};
</script>
<style scoped lang="less">
.box-card{
  margin-bottom: 4px;
}
</style>


